import { render, staticRenderFns } from "./task.vue?vue&type=template&id=a43f7f6c&scoped=true&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"
import style0 from "./task.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./task.vue?vue&type=style&index=1&id=a43f7f6c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43f7f6c",
  null
  
)

export default component.exports